// extracted by mini-css-extract-plugin
export default {"error":"signup_error__LKBWc","signup":"signup_signup__OGid3"};